module.exports = __webpack_public_path__ + "img/html-evolution-11.b61b43ac.webp";